import axios from "axios";
import { isBrowser } from "../util/env-utils";

const getBackendEndpoint = () =>
  (isBrowser ? (window as any).BACKEND_ENDPOINT : undefined) ||
  process.env.BACKEND_ENDPOINT;

export async function fetchCpfHash(token: string): Promise<string | null> {
  const response = await axios.get<{ hashUserCpf: string | null }>(
    `${getBackendEndpoint()}/v1/user/cpf-hash`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return response.data.hashUserCpf;
}
